import moment from 'moment';

import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  ViewChild
} from '@angular/core';

import {
  ControlContainer,
  NgForm,
  NgModel
} from '@angular/forms';

import { DATE_CONFIGURATIONS }  from '../../constants/date.configurations.constant';
import { TextControlComponent } from '../text-control/text-control.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector       : 'wor-time-control',
  template: require('./time-control.component.html'),
  viewProviders  : [
    {
      provide    : ControlContainer,
      useExisting: NgForm
    }
  ]
})
export class TimeControlComponent extends TextControlComponent implements AfterViewInit, OnDestroy {
  public _model        : string;
  public _picker       : any;
  public _timeSettings = DATE_CONFIGURATIONS.time;

  @Input() set model ( _model : string ) {
    this._model = moment(_model, this._timeSettings.formats.model).isValid()
      ? this.parseModel(_model)
      : _model;
  }

  get model () : string {
    if ( moment(this._model, this._timeSettings.formats.view).isValid() ) {
      return this.formatModel(this._model);
    }

    return this._model;
  }

  @ViewChild('input')  ngModel      : NgModel;
  @ViewChild('picker') pickerButton : ElementRef<HTMLButtonElement>;

  ngAfterViewInit () : void {
    this._picker = $(this.pickerButton.nativeElement).datetimepicker({
      initialDate : new Date(),
      showMeridian: true,
      startView   : 'day'
    })
    .on('changeDate', ( event : any ) => this.handleTimeSelection(event));
  }

  ngOnDestroy () : void {
    if (this._picker) {
      this._picker.datetimepicker('remove');
    }
  }

  formatModel ( model = this.model ) : string {
    return moment(model, this._timeSettings.formats.view)
    .format(this._timeSettings.formats.model);
  }

  handleBlur ( event : FocusEvent ) : void {
    if (this.ngModel.control.valid) {
      this.model = this.formatModel(this._model);

      this.modelChange.emit(this.model);
    }

    this.blur.emit(event);
  }

  handleTimeSelection ( event : any ) : void {
    const date = event.date;

    if ( moment(date).isValid ) {
      this.model = moment(date)
      .utc()
      .set({ second: 0 })
      .format(this._timeSettings.formats.model);

      this.modelChange.emit(this.model);

      this.ngModel.control.updateValueAndValidity();
    }


    this._picker.datetimepicker('hide');
  }

  parseModel ( model : string ) : string {
    return moment(model, this._timeSettings.formats.model)
      .format(this._timeSettings.formats.view);
  }
}
